import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getFromLocalStorage, getSessionToken } from "../../services/userService";

const ChildRoute = ({ component: Component, authed, title, ...rest }) => {
  if (!authed) {
    const { user, parties } = getFromLocalStorage();
    authed = user && getSessionToken() && parties;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        authed ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
            }}
          />
        )
      }
    />
  );
};

export default ChildRoute;
